<div *ngIf="!showModal" class="modal-container">
  <h1 mat-dialog-title class="modal-title">Selecciona el Servicio</h1>
  
  <div class="modal-info">
    <h5>Tipo Servicio: <span>{{tipoServicio}}</span></h5>
    <h5>Categoría Servicio: <span>{{categoriaServicio}}</span></h5>
    <h5>Proveedor: <span>{{nombreProvedor}}</span></h5>
    <h5>Locación: <span>{{locacion}}</span></h5>
  </div>

  <div mat-dialog-content class="modal-content">
    <mat-form-field appearance="fill" *ngIf="!isLoading" class="search-field">
      <mat-label class="search-field">Buscar Servicio</mat-label>
      <input matInput [(ngModel)]="newService" [matAutocomplete]="auto" (ngModelChange)="filterServices($event)">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText" (optionSelected)="onChange($event.option.value)">
        <mat-option *ngFor="let service of filteredServices" [value]="service" matTooltip="{{service.nombreServicio}}">
          {{service.nombreServicio}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div *ngIf="isLoading" class="loading-spinner">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div mat-dialog-actions class="modal-actions">
    <button mat-button (click)="onNoClick()" class="button-secondary">Cancelar</button>
    <button mat-button class="button-primary" (click)="saveChangeServices()" cdkFocusInitial>Guardar</button>
  </div>
</div>

<div *ngIf="showModal" class="modal-result">
  <div class="result-icon">
    <mat-icon *ngIf="iconResult" class="icon-check">check_circle</mat-icon>
    <mat-icon *ngIf="!iconResult" class="icon-error">error_outline</mat-icon>
  </div>

  <div class="result-message">
    <p class="message-result" *ngIf="!isLoadingResult; else spinner"><i>{{messageResult}}</i></p>
  </div>

  <ng-template #spinner>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
